// Types
import { TooltipDecorator, TooltipDecoratorTypesEnum } from '@molecules/index';
import { LineTooltipSpeedFocProps } from './LineTooltipSpeedFoc.types';
// Utils
import { formatKN, formatMT } from '@helpers/index';
import text from '@translations/en.json';

/**
 * LineTooltipWrapper is a component that wraps a Victory bar tooltip with custom content.
 *
 * @component
 * @param {LineTooltipSpeedFocProps} props - Props for the BarTooltipWrapper component.
 * @param {VesselRatingSummary} props.datum - The data point object for which the tooltip is being rendered.
 * @param {number} [props.x=0] - The x-coordinate of the tooltip position.
 * @param {number} [props.y=0] - The y-coordinate of the tooltip position.
 * @returns {ReactElement} A component that renders a custom tooltip for a Victory bar.
 */
export const LineTooltipSpeedFoc = ({ x = 0, y = 0, datum }: LineTooltipSpeedFocProps) => {
  // Destructure properties from the datum object, the assertion comes from the
  // the non type model of victory to use {datum}.
  const { x: xValue = 0, y: yValue = 0, title = '' } = datum ?? {};
  const labels = [`${text.foc}: ${formatMT(yValue)}`, `${text.speed}: ${formatKN(xValue, 1)}`];
  const xAxisCorrection = x - 45;

  return (
    <TooltipDecorator
      type={TooltipDecoratorTypesEnum.LabelTooltip}
      positionObject={{
        x: xAxisCorrection,
        y,
      }}
      title={title}
      params={{
        labels,
      }}
    />
  );
};
